<div class="pricing-table">
  <h2 class="mat-h2">{{ product.name }}</h2>
  <div class="subtle">
    <p class="mat-body-2">{{ product.description }}</p>
  </div>
  <div class="price">
    <span class="amount"
      ><del>{{ product.price }}</del></span
    >
    <span class="mat-body-2">/{{ product.period }}</span>
  </div>
  <mat-divider [vertical]="false"></mat-divider>
  <ul class="features">
    <li *ngFor="let feature of product.marketing_features">
      {{ feature.name }}
    </li>
  </ul>
  <p class="mat-body-2">Add your promotion code at checkout to get your discount.</p>
  <div class="call-to-action">
    <button mat-raised-button color="primary" (click)="onSubscribe($event)">Checkout</button>
  </div>
  <div class="subtle">
    <p class="mat-body-2">
      Need a promotion code?
      <button mat-button color="primary" (click)="onPromoCode()">Apply here</button>
    </p>
  </div>
</div>
